var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { isObject } from '@autobest-ui/utils';
/**
 * 请求参数分解成需要的格式
 * @param url
 * @param method
 * @param params
 * @param body
 * @param options
 */
export default function disassembleRequestArgs(url, method, params, body, options) {
  if (!isObject(options)) {
    return {
      url: url,
      method: method,
      params: params,
      requestConfig: {
        body: body,
        method: method
      }
    };
  }
  var requestConfig = options.requestConfig,
    extraOptions = __rest(options, ["requestConfig"]);
  return __assign(__assign({}, extraOptions), {
    url: url,
    method: method,
    params: params,
    requestConfig: isObject(requestConfig) ? __assign(__assign({}, requestConfig), {
      body: body,
      method: method
    }) : {
      body: body,
      method: method
    }
  });
}